import React from 'react';
import { FaFacebook, FaInstagram} from "react-icons/fa";
import '../styles/Footer.css';

const Footer = () => {

  return (
    <div className='footer' id='footer'>
      <iframe
        title="hotel-location"
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15268.657855522913!2d79.59326906855311!3d30.705049547498103!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39a79104df119273%3A0x8f14426be5901018!2sHotel%20Shyam%20Palace!5e1!3m2!1sen!2sin!4v1730352454410!5m2!1sen!2sin"
        width="600"
        height="450"
        loading="lazy">
      </iframe>
      <div className="footer-contact">
        <h1>&copy; {new Date().getFullYear()} Hotel Shyam Palace. All rights reserved.</h1>
        <h3>Contact Us</h3>
        <p>📞 +91 9045502946</p>
        <p>📍 Ghangaria, Uttarakhand, India</p>
        <a className='refund-btn' href="/privacy_policy" target="_blank">Privacy Policy</a>
        <a className='refund-btn' href="/terms_and_conditions" target="_blank">Terms & Conditions</a>
        <a className='refund-btn' href="/refundForm" target="_blank">Cancel Booking</a>
      </div>
      <div className="social-icons">
        <p>You can also connect with us through Facebook and Instagram.</p>
        <div className='connect-box social-box'>
          <a href="https://www.facebook.com/share/16q5RvmEf5/?mibextid=wwXIfr" className="icon facebook" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FaFacebook size={25}/>
          </a>
          <a href="https://www.instagram.com/hotelshyampalaceghangaria?igsh=aDVoNzNiOGR6cTV6" className="icon instagram"  target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FaInstagram size={25}/>
          </a>
        </div>
      </div>
    </div>
  )
}

export default Footer;
